import React from 'react';

function ButtonRectangle(props) {
    return (
        <div>
            <button type="button" className="btn mainGradBK whiteFont padding20Side delay">
                <div>
                    {props.label}
                </div>
            </button>
        </div>

    );
}

export default ButtonRectangle;